/**
 * Plachta «Tvoja cena … s kódom …».
 *
 * 1) Prepočet pri zmene varianty — Liquid vykreslí cenu pre aktuálnu variantu,
 *    ale po prepnutí objemu či odtieňa by ukazoval cenu inej.
 * 2) Kliknutie na plachtu kód rovno uplatní: /discount/KÓD ho uloží do košíka (aj budúceho)
 *    a pokladňa zľavu odpočíta sama. Ak to zlyhá, kód skopírujeme do schránky ako zálohu.
 */
(function () {
  'use strict';

  var box = document.querySelector('[data-mk-promo]');
  if (!box) return;

  var priceBox = box.querySelector('[data-mk-promo-price]');
  var btn = box.querySelector('[data-mk-promo-copy]');
  var hintBox = box.querySelector('[data-mk-promo-hint]');
  var percent = Number(box.dataset.percent) || 0;
  var handle = box.dataset.handle || '';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var variants = null;

  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'sk-SK',
        { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  // --- prepočet ceny ---

  function currentVariantId() {
    var fromUrl = new URLSearchParams(location.search).get('variant');
    if (fromUrl) return fromUrl;
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input && input.value;
  }

  function update() {
    if (!variants || !priceBox || !percent) return;
    var id = currentVariantId();
    var v = variants.filter(function (x) { return String(x.id) === String(id); })[0] || variants[0];
    if (!v) return;
    // rovnako ako pokladňa: zľavu zaokrúhlime nadol na cent a odpočítame ju
    priceBox.textContent = money(v.price - Math.floor(v.price * percent / 100));
    box.hidden = !v.available;
  }

  if (handle && percent) {
    fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) { variants = p.variants; update(); } })
      .catch(function () {});
  }

  if (window.eventBus && typeof window.eventBus.on === 'function') {
    ['variant:change', 'variant:changed'].forEach(function (e) { window.eventBus.on(e, update); });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) setTimeout(update, 120);
  }, true);

  // --- kopírovanie kódu (záloha) ---

  // Schránka cez navigator.clipboard funguje len na https a po geste používateľa.
  // Staršie prehliadače a webview v aplikáciách ju nemajú, preto záložný spôsob.
  function copyFallback(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.top = '-1000px';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function copy(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).then(function () { return true; })
        .catch(function () { return copyFallback(text); });
    }
    return Promise.resolve(copyFallback(text));
  }

  // Ak schránka nie je dostupná, kód aspoň označíme — zákazník ho skopíruje sám.
  function selectCode() {
    try {
      var r = document.createRange();
      r.selectNodeContents(btn);
      var s = window.getSelection();
      s.removeAllRanges();
      s.addRange(r);
    } catch (e) {}
  }

  // --- uplatnenie kódu ---

  // Shopify si uplatnený kód pamätá v cookie discount_code (môže ich byť viac, oddelené čiarkou).
  function hasCode(code) {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return false;
    var v = m[1];
    try { v = decodeURIComponent(v); } catch (e) {}
    return v.toUpperCase().split(',').indexOf(code.toUpperCase()) !== -1;
  }

  // Rovnaký mechanizmus ako zdieľateľný odkaz na zľavu: kód sa pridá do košíka,
  // a ak košík ešte nie je, uplatní sa pri prvom pridaní tovaru.
  function apply(code) {
    var url = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok; })
      .catch(function () { return false; });
  }

  function showApplied() {
    box.classList.remove('mk-promo--copied');
    box.classList.add('mk-promo--applied');
    if (hintBox) hintBox.textContent = box.dataset.applied || 'Kód uplatnený ✓';
  }

  var code0 = box.dataset.code || (btn && btn.textContent.trim()) || '';
  if (code0 && hasCode(code0)) showApplied();

  var timer = null;
  var busy = false;
  // Uplatňuje sa kliknutím kdekoľvek na plachtu, nielen na samotný kód.
  box.addEventListener('click', function () {
    var code = code0;
    if (!code || busy) return;
    busy = true;
    apply(code).then(function (ok) {
      busy = false;
      clearTimeout(timer);
      if (ok) { showApplied(); return; }
      // Záloha: kód skopírujeme (alebo aspoň označíme), nech ho zákazník vloží sám.
      copy(code).then(function (copied) {
        if (!copied) selectCode();
        box.classList.add('mk-promo--copied');
        if (hintBox) {
          hintBox.textContent = copied
            ? (box.dataset.copied || 'Kód skopírovaný ✓')
            : (box.dataset.manual || 'Kód je označený — skopírujte ho');
        }
        timer = setTimeout(function () {
          box.classList.remove('mk-promo--copied');
          if (hintBox) hintBox.textContent = box.dataset.hint || '';
        }, copied ? 2000 : 4000);
      });
    });
  });
})();
